import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import firebase from 'firebase/compat/app';
import { AuthService } from 'src/app/auth/auth.service';
@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OTPComponent implements OnInit, AfterViewInit {
  @Input() phoneNumber: string = '';
  isTwilio = false;
  appVerifier: firebase.auth.RecaptchaVerifier;
  confirmationResult: firebase.auth.ConfirmationResult;
  otp: string;
  canResend = false;
  timerText = ''; // Text to display the timer
  resendLoading = false;
  isSent = false;
  isVerifying = false;
  private timer: any;
  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private authService: AuthService
  ) { }

  ngOnInit() { }

  ngAfterViewInit() { }

  sendOtp() {
    this.handleResend();
    this.resendLoading = false;
    this.isSent = true;

    this.authService.sendOTP(this.phoneNumber).subscribe((res) => {
      if (res) {
        this.isTwilio = true;
      }
    });
  }

  // sendOtp() {
  //   this.resendLoading = true;
  //   let phoneNumber;
  //   if (!this.phoneNumber.startsWith('+')) {
  //     phoneNumber = `+${this.phoneNumber}`; // Replace with user-entered phone number
  //   } else {
  //     phoneNumber = this.phoneNumber;
  //   }

  //   this.appVerifier
  //     .verify()
  //     .then((token) => {
  //       console.log('reCAPTCHA verified with token:', token);

  //       // Proceed to send OTP
  //       this.afAuth
  //         .signInWithPhoneNumber(phoneNumber, this.appVerifier)
  //         .then((confirmationResult) => {
  //           this.isTwilio = false;
  //           console.log('OTP sent successfully.');
  //           this.confirmationResult = confirmationResult;
  //           this.handleResend();
  //           this.resendLoading = false;
  //         })
  //         .catch((error) => {
  //           this.authService.sendOTP(phoneNumber).subscribe((res) => {
  //             if (res) {
  //               this.isTwilio = true;
  //               this.handleResend();
  //               this.resendLoading = false;
  //             }
  //           });
  //         });
  //     })
  //     .catch((error) => {
  //       console.error('reCAPTCHA verification failed:', error);
  //       this.resendLoading = false;
  //     });
  // }

  resetRecaptcha() {
    this.appVerifier.render().then((widgetId) => {
      // grecaptcha.reset(widgetId);
      console.log('reCAPTCHA reset.');
    });
  }

  verifyOtp() {
    // if (this.isTwilio == false) {
    //   this.confirmationResult
    //     .confirm(this.otp)
    //     .then((result) => {
    //       this.modalCtrl.dismiss(result);
    //     })
    //     .catch((error) => {
    //       this.alertCtrl
    //         .create({
    //           header: 'OTP Verification Failed',
    //           message:
    //             'Try again. If the problem persists, resend the verification code.',
    //           buttons: [
    //             {
    //               text: 'Dismiss',
    //               handler: () => {
    //                 this.alertCtrl.dismiss();
    //               },
    //             },
    //           ],
    //         })
    //         .then((alertEl) => alertEl.present());
    //     });
    // } else {
    this.isVerifying = true;
    this.authService.verifyOTP(this.phoneNumber, this.otp).subscribe({
      next: (result) => {
        if (result) {
          this.isVerifying = false;
          this.modalCtrl.dismiss(result);
        } else {
          this.alertCtrl
            .create({
              header: 'OTP Verification Failed',
              message: 'If the problem persists, resend the verification code.',
              buttons: [
                {
                  text: 'Dismiss',
                  handler: () => {
                    this.isVerifying = false;
                    this.alertCtrl.dismiss();
                  },
                },
              ],
            })
            .then((alertEl) => alertEl.present());
        }
      },
      error: (error) => {
        this.alertCtrl
          .create({
            header: 'OTP Verification Failed',
            message: 'If the problem persists, resend the verification code.',
            buttons: [
              {
                text: 'Dismiss',
                handler: () => {
                  this.alertCtrl.dismiss();
                  this.isVerifying = false;
                },
              },
            ],
          })
          .then((alertEl) => alertEl.present());
      },
    });
  }

  onCancel() {
    this.modalCtrl.dismiss();
  }

  handleResend() {
    let timeLeft = 60; // 60 seconds
    this.timerText = `Re-send code in ${timeLeft}s`;
    this.canResend = false;
    this.timer = setInterval(() => {
      timeLeft--;
      this.timerText = `Re-send code in ${timeLeft}s`;

      if (timeLeft <= 0) {
        clearInterval(this.timer); // Clear the interval
        this.canResend = true; // Re-enable the button
        this.timerText = ''; // Clear the timer text
      }
    }, 1000);
  }
}
